import { render, staticRenderFns } from "./TipTransactionDetails.vue?vue&type=template&id=36b94300&"
import script from "./TipTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./TipTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports